import { render, staticRenderFns } from "./FormReason.vue?vue&type=template&id=352471e4&"
import script from "./FormReason.vue?vue&type=script&lang=js&"
export * from "./FormReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports